import OverflowMenuVertical16 from '@carbon/icons-react/es/overflow-menu--vertical/16';
import Warning20 from '@carbon/icons-react/es/warning/20';
import { Dropdown, Modal } from 'antd';
import React, { FC } from 'react';
import { Button } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';
import { ClassNamePropsWithChildren } from 'components/ozone-component';
import { useTranslation } from 'hooks/use-translation';
import styles from './approval.module.css';

interface MoreActionsMenuProps extends ClassNamePropsWithChildren {
  overlayClassName?: string;
  approvalId: number;
  onDelete: (approvalId: number) => Promise<unknown>;
}

export const MoreActionsMenu: FC<MoreActionsMenuProps> = (props) => {
  const { approvalId, onDelete } = props;
  const translatedDeleteConfirmTitleText = useTranslation(
    'approvals.delete.confirm_title',
  );
  const translatedDeleteConfirmMessageText = useTranslation(
    'approvals.delete.confirm_message',
  );
  const translatedDeleteText = useTranslation('delete');
  const translatedCancelText = useTranslation('cancel');
  const { confirm } = Modal;

  const openDeleteConfirmation = () =>
    confirm({
      className: styles.delete_confirm_modal,
      title: translatedDeleteConfirmTitleText,
      icon: <Warning20 className={styles.delete_confirm_modal__title_icon} />,
      content: translatedDeleteConfirmMessageText,
      okText: translatedDeleteText,
      okType: 'danger',
      okButtonProps: {
        type: 'primary',
        size: 'small',
      },
      cancelText: translatedCancelText,
      cancelButtonProps: {
        type: 'ghost',
        size: 'small',
      },
      onOk: () => onDelete(approvalId),
      onCancel: () => {},
    });

  const MenuItems = () => (
    <Menu>
      <Menu.ItemDelete key="delete" onClick={openDeleteConfirmation} />
    </Menu>
  );

  return (
    <Dropdown
      className={styles.more_actions}
      overlay={MenuItems}
      trigger={['click']}
    >
      <Button
        aria-label="ellipsis"
        icon={<OverflowMenuVertical16 />}
        size="small"
        type="text"
      />
    </Dropdown>
  );
};
